import dayjs from 'dayjs';

export default (date) => {
    if (!date) return ''
    return dayjs(date).format("M/D/Y");
};

export const getMonthAbbreviation = (date) => {
    if (!date) return '';
    return dayjs(date).format("MMM");
}

export const getDayOnly = (date) => {
    if (!date) return '';
    return dayjs(date).date();
}

export const getYearOnly = (date) => {
    if (!date) return '';
    return dayjs(date).format("YYYY");
}
